import script from "./IconText.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconText.vue?vue&type=script&lang=ts&setup=true"

import "./IconText.vue?vue&type=style&index=0&id=08b48921&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b48921"]])

export default __exports__